import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutPreview from "./sections/AboutPreview";
import CoreServicesOverview from "./sections/CoreServicesOverview";
import FilmDevelopmentHighlight from "./sections/FilmDevelopmentHighlight";
import Testimonials from "./sections/Testimonials";
import ContactCallToAction from "./sections/ContactCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutPreview />
      <CoreServicesOverview />
      <FilmDevelopmentHighlight />
      <Testimonials />
      <ContactCallToAction />
      <Footer />
    </div>;
}